<template>
  <table class="index-table">
    <thead>
      <tr class="border-b border-terracotta">
        <th class="border-r border-gray-300">Year</th>
        <th>Jan</th>
        <th>Feb</th>
        <th>Mar</th>
        <th>Apr</th>
        <th>May</th>
        <th>Jun</th>
        <th>Jul</th>
        <th>Aug</th>
        <th>Sep</th>
        <th>Oct</th>
        <th>Nov</th>
        <th>Dec</th>
        <th class="border-l border-gray-300">Return</th>
        <th>Cum. Return</th>
        <th>Vol.</th>
        <th>Cum. Vol.</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="year in years" :key="year">
        <th class="border-r border-gray-300">{{ year }}</th>
        <td v-for="month in monthsList" :key="month">
          <index-value
            @click="onValueClicked(year, month)"
            @addButtonClicked="onAddButtonClicked(year, month)"
            @unpublishButtonClicked="onUnpublishButtonClicked(year, month)"
            :indexValue="monthValue(year, month)"
            :isLast="lastReport.year === year && lastReport.month === month"
            :isCurrent="nextReport.year == year && nextReport.month === month"
          />
        </td>
        <td class="border-l border-gray-300">
          {{ getLastIndexValueForYear(year).return | percent }}
        </td>
        <td>{{ getLastIndexValueForYear(year).cumulatedReturn | percent }}</td>
        <td>{{ getLastIndexValueForYear(year).ytdVolatility | percent }}</td>
        <td>
          {{ getLastIndexValueForYear(year).cumulatedVolatility | percent }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import IndexValue from './IndexValue.vue'

export default {
  components: {
    IndexValue,
  },
  props: {
    monthlyIndexValues: {
      type: Array,
      required: true,
    },
  },
  computed: {
    yearsWithValues() {
      return [...new Set(this.monthlyIndexValues.map((v) => v.year))].sort(
        (a, b) => b - a,
      )
    },
    years() {
      return new Set([this.nextReport.year, ...this.yearsWithValues])
    },
    monthsList() {
      let months = []
      for (let i = 1; i < 13; i++) {
        months.push(i)
      }
      return months
    },
    lastReport() {
      const year = Math.max(...this.yearsWithValues)
      const monthsInYear = this.monthlyIndexValues
        .filter((v) => v.year == year)
        .map((v) => v.month)
      const month = Math.max(...monthsInYear)
      return { year, month }
    },
    nextReport() {
      let year = this.lastReport.year
      let month = this.lastReport.month + 1
      if (month > 12) {
        year++
        month = 1
      }
      return { year, month }
    },
  },
  methods: {
    monthValue(year, month) {
      const indexValue = this.monthlyIndexValues.find(
        (v) => v.year === year && v.month === month,
      )

      if (indexValue) {
        return {
          value: indexValue.value,
          periodVariation: indexValue.periodVariation,
        }
      }

      return null
    },
    onValueClicked(year, month) {
      this.$emit('valueClicked', { year, month })
    },
    onAddButtonClicked(year, month) {
      this.$emit('addValueButtonClicked', { year, month })
    },
    onUnpublishButtonClicked(year, month) {
      this.$emit('unpublishButtonClicked', { year, month })
    },
    getLastIndexValueForYear(year) {
      const selectedYearValues = this.monthlyIndexValues.filter(
        (v) => v.year === year,
      )
      const sortedValues = selectedYearValues.sort((a, b) => a.month - b.month)
      return (
        sortedValues[sortedValues.length - 1] || {
          return: 0,
          cumulatedReturn: 0,
          ytdVolatility: 0,
          cumulatedVolatility: 0,
        }
      )
    },
  },
  filters: {
    percent: function (value) {
      const formattedValue =
        (Math.abs(value) * 100).toLocaleString('en-us', {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }) + '%'
      if (value < 0) {
        return `(${formattedValue})`
      } else {
        return formattedValue
      }
    },
  },
}
</script>

<style scoped>
.index-table td,
.index-table th {
  @apply py-1 px-2 text-right text-xs;
}
</style>
